export default function getLanguage(local) {
  const isApp = (navigator.userAgent.toLowerCase().match(/cfmoto/i) && true) || false;
  let queryLocale = local ? local.split(/[-_]/)[0] : '';
  console.log('app语言');
  console.log(queryLocale);
  const navigatorLanguage = navigator.language.split('-')[0];
  if (!isApp) {
    const localLanguage = JSON.parse(window.localStorage.getItem('language') || '""');
    if (navigatorLanguage != localLanguage) {
      window.localStorage.setItem('language', JSON.stringify(navigatorLanguage));
    }
  }
  return {
    queryLocale,
    navigatorLanguage,
  };
}
